import { render, staticRenderFns } from "./ConfirmTwoFactor.vue?vue&type=template&id=58f663e8&scoped=true&"
import script from "./ConfirmTwoFactor.vue?vue&type=script&lang=js&"
export * from "./ConfirmTwoFactor.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmTwoFactor.vue?vue&type=style&index=0&id=58f663e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f663e8",
  null
  
)

export default component.exports